import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { AutoLogoutService } from './core/common/services/auto-logout.service';
import { AuthService } from './core/auth/auth.service';
import { TokenRefreshService } from './core/auth/token-refresh.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    userRole: string;

    /**
     * Constructor
     */
    constructor(private autoLogoutService: AutoLogoutService,
        private _authService: AuthService,
        private _tokenRefreshService: TokenRefreshService) {

    }

    ngOnInit() {
        this.autoLogoutService.startMonitoring();
        // Boot proactive silent refresh. Idempotent — runs in the background while the tab is open.
        this._tokenRefreshService.start();
        this.userRole = this._authService.getRolesFromToken();
    }

    ngOnDestroy() {
        this.autoLogoutService.stopMonitoring();
    }
}
